import { useAuth } from '@/hooks/use-auth';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { LoadingSpinner } from '@/components/shared/loading-spinner';

export function LoginPage() {
  const { login, logout, isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();
  // Terminal state: the account is deactivated/expired. The IdP session may
  // still be valid, so we must NOT auto-login (that loops). Show a message and
  // let the user explicitly sign out.
  const isInactive = searchParams.get('reason') === 'inactive';

  useEffect(() => {
    if (!isInactive && !isLoading && !isAuthenticated) {
      login();
    }
  }, [isInactive, isLoading, isAuthenticated, login]);

  if (isInactive) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="max-w-md text-center">
          <h1 className="mb-4 text-2xl font-bold text-foreground">Cuenta inactiva</h1>
          <p className="mb-6 text-sm text-muted-foreground">
            Tu cuenta fue desactivada o tu acceso expiró. Si creés que es un error, contactá al
            administrador del sistema.
          </p>
          <button
            type="button"
            onClick={logout}
            className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold text-foreground">Grupo DIM — Mi Capacitación</h1>
        <LoadingSpinner />
        <p className="mt-4 text-sm text-muted-foreground">Redirigiendo al inicio de sesión...</p>
      </div>
    </div>
  );
}
